import React, { useEffect, useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { useScrolled } from '../hooks/useScrolled';
import { bookingItem, business, navItems } from '../data/site';
export function SiteHeader() {
  const scrolled = useScrolled();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  const solid = scrolled || open;
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-200 ease-out ${solid ? 'border-b border-white/10 bg-ink/85 backdrop-blur-xl' : 'border-b border-transparent bg-transparent'}`} data-id="element-181" data-mp="14wy9rmqx5ptk">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-5 sm:px-8" data-id="element-182" data-mp="2bch9da4xroi3">
        <Logo data-id="element-183" data-mp="29jtyss8ngold" />

        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-184" data-mp="29kbtvljkswrp">
          <ul className="flex items-center gap-1" data-id="element-185" data-mp="2eiwrrebcv4cz">
            {navItems.map(item => <li key={item.to} data-id="element-186" data-mp="2ekq336wwycrb">
                <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-lime ${isActive ? 'bg-white/10 text-white' : 'text-white/70 hover:text-white'}`} data-id="element-187" data-mp="2jhq7lde477gb">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-188" data-mp="183mcu4zpdfa7">
          <a href={business.phoneHref} className="hidden whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium text-white/80 transition-colors duration-150 ease-out hover:text-white xl:inline-flex xl:items-center xl:gap-2" data-id="element-189" data-mp="181096gfxnjx9">
            <PhoneIcon className="h-4 w-4 text-lime" aria-hidden="true" data-id="element-190" data-mp="101dd671jygdl" />
            {business.phone}
          </a>
          <Link to={bookingItem.to} className="hidden whitespace-nowrap rounded-full bg-lime px-5 py-2.5 text-sm font-semibold text-ink transition-[transform,background-color] duration-150 ease-out hover:bg-white active:scale-[0.97] sm:inline-flex" data-id="element-191" data-mp="1eq9kg1vsbpd5">
            {bookingItem.label}
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-white lg:hidden" data-id="element-192" data-mp="w0a0tuipr2h4">
            {open ? <XIcon className="h-5 w-5" data-id="element-193" data-mp="22gc7g3kue54w" /> : <MenuIcon className="h-5 w-5" data-id="element-194" data-mp="2a0eiijdga358" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-195" data-mp="2ez7xyhcas481">
        {open && <motion.nav id="mobile-menu" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-white/10 px-5 pb-6 pt-2 lg:hidden" data-id="element-196" data-mp="2f0972g9r6gn4">
            <ul className="flex flex-col" data-id="element-197" data-mp="2xq8tswi4fjnd">
              {[...navItems, bookingItem].map(item => <li key={item.to} data-id="element-198" data-mp="2jz42chowpxo4">
                  <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `block border-b border-white/5 py-3.5 font-display text-2xl font-semibold ${isActive ? 'text-lime' : 'text-white'}`} data-id="element-199" data-mp="2jxsw8b7zodtu">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
            <a href={business.phoneHref} className="mt-5 flex items-center justify-center gap-2 rounded-full bg-lime py-3.5 font-semibold text-ink" data-id="element-200" data-mp="1nt2c1e5lfj9u">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-201" data-mp="1iu7tmdbjfwq9" />
              {business.phone}
            </a>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}